import {url} from "../utils";
import {AjaxDataLoad} from "../../modules/shared/components/ajax-data-load/ajax-data-load";

class Analytics {
    constructor() {

    }

    static userId = null;

    static setUserId(id) {
        Analytics.userId = id;
    }

    static track(generic_name, data) {
        data.eventData['event_type_id'] = data.type_id;
        Analytics.trackInGA(generic_name, data.eventData);
        
        const localData = AjaxDataLoad.extendDataLoad({
            'type_id': data.type_id,
            'uri': docPath.page,
            ...data.localData
        });
        
        framework.post(url('api/log_generic_event'), localData);
    }

    static trackInGA(event, p) {
        var params = p || {};
        params = Object.assign({
            page: docPath.page
        }, params);
        if (typeof gtag !== 'undefined') {
            gtag('event', event, params);
        }
    }

    static trackConversion(key, p) {
        var params = p || {};
        params = Object.assign({
            'send_to': 'AW-1071951115/'+key
        }, params);
        if (typeof gtag !== 'undefined') {
            gtag('event', 'conversion', params);
        }
    }
}

export {
    Analytics
}